export const validations = {
  numbersOnly: /^[0-9]+$/,
  emptyOrNumbersOnly: /^[0-9]*$/,
  lettersOnly: /^[a-zA-ZÄÜÖäüöß]+$/,
  lettersAndNumbersOnly: /^[a-zA-ZÄÜÖäüöß0-9]+$/,
  letterAndSpecialCharactersOnly: /^[a-zA-ZäöüÄÖÜß\-\(\)\'’\/. ]+$/,
  emptyOrLettersAndNumbersOnly: /^[a-zA-ZÄÜÖäüöß0-9]*$/,
  lettersName: /^[a-zA-ZÄÜÖäüöß-\s]+$/,
  atLeastOneUppercase: /.*[A-ZÄÜÖß]+.*/,
  atLeastOneLowercase: /.*[a-zäüöß]+.*/,
  atLeastOneNumber: /.*[0-9]+.*/,
  startWithNumber: /^\d/,
  allowSlashMinus: /^[a-zA-Z0-9]+(?:[-\/ ][a-zA-Z0-9]+)*$/,
  atLeastOneSpecialCharacter: /[^\w]/,
  slashMinus: /[-\/ ]/,
  houseNumber: /^[0-9]+(?:[-\/ ](([a-zA-Z])|([0-9]+)))$/,
  specialCharacters: /[^A-z\s\d][\\\^]?/,
  // Combined at least 8 characters, one uppercase, one lowercase, one number and one special character
  passwordValidation: /^(?=.*[a-zäüöß])(?=.*[A-ZÄÜÖß])(?=.*[0-9])(?=.*[^\w]).{8,}$/,
}

export const slugWithIdRegex = /(?:)\d+/g
